var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterwind1S200Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -7.5)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 41,
    r: 10,
    fill: "#0055a5",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "0;15;0",
    keySplines: "0.2 0 0.8 1;0.2 0 0.8 1",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 41,
    r: 10,
    fill: "#45aee7",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "180 50 50;540 50 50",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "15;0;15",
    keySplines: "0.2 0 0.8 1;0.2 0 0.8 1",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterwind1S200Px);
export default __webpack_public_path__ + "static/media/Interwind-1s-200px.fbd30dc9d76eead19494d99c6fdf3e0f.svg";
export { ForwardRef as ReactComponent };